import { useState, useEffect } from 'react';
import { useStateDispatch } from '../store/';
import { updatePostCodeInSearch } from '../reducers/search/searchReducer';

/* globals CSS_CONFIG */

interface UseZipCodeStates {
  newZipCode: string;
}

interface UseZipCodeActions {
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const regex = new RegExp(CSS_CONFIG?.regExp?.zipCode);

export const isZipCodeValid = (value: string) => {
  return !!value && regex.test(value);
};

export default function useZipCode(
  defaultValue: string,
  setIsValid: (value: boolean) => void,
): [UseZipCodeStates, UseZipCodeActions] {
  const dispatch = useStateDispatch();

  const [newZipCode, setNewZipCode] = useState(defaultValue);
  const [checkValidation, setCheckValidation] = useState(false);

  useEffect(() => {
    dispatch(updatePostCodeInSearch(newZipCode));
  }, [dispatch, newZipCode]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.currentTarget;
    setNewZipCode(value);

    if (checkValidation) {
      setIsValid(isZipCodeValid(value));
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    const { value } = e.currentTarget;
    setIsValid(isZipCodeValid(value));
    setCheckValidation(true);
  };

  return [{ newZipCode }, { handleBlur, handleChange }];
}
